import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Locations from './pages/Locations';
import ScrollToTop from './components/ScrollToTop';
import MaintenanceModal from './components/MaintenanceModal';

// Set to false to bring the site back online
const MAINTENANCE_MODE = true;

// Import other pages once created

function App() {
    return (
        <Router>
            {MAINTENANCE_MODE && <MaintenanceModal/>}
            <ScrollToTop/>
            <Navbar/>
            <main>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/about" element={<About/>}/>
                    <Route path="/contact" element={<Contact/>}/>
                    <Route path="/services" element={<Services/>}/>
                     <Route path="/locations" element={<Locations />} />
                </Routes>
            </main>
            <Footer/>
        </Router>
    );
}

export default App;